import {AfterViewInit, Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID, ViewChild} from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import {ProcessService} from '../../../../services/user-services/process.service';
import {AuthenticationService} from '../../../../services/authentication.service';
import {UserService} from '../../../../services/user-services/user.service';
import {document} from 'ngx-bootstrap/utils';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {finalize} from 'rxjs/operators';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import {MapConfiguration} from '../../../../interfaces/MapConfiguration.interface';
import {ProcessSharedService} from '../../../../services/process-shared.service';
import { ComponentModalFavoriteComponent } from '../../../../pages/processes/accommodation/components/component-modal-favorite/component-modal-favorite.component';
import { SliderComponent } from '../../ux/slider/slider.component';
import { FaqAccordionComponent } from '../../../../components/faq-accordion/faq-accordion.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatExpansionModule } from '@angular/material/expansion';
import { AccommodationPriceBoxComponent } from '../accommodation-price-box/accommodation-price-box.component';
import { AccommodationFeaturesComponent } from '../accommodation-features/accommodation-features.component';
import { AccomRoomspecComponent } from '../accom-roomspec/accom-roomspec.component';
import { CheckImageUrlDirective } from '../../../../directives/check-image-url.directive';
import { NgIf, NgClass, isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-accommodation-modal-details',
    templateUrl: './accommodation-modal-details.component.html',
    styleUrls: ['./accommodation-modal-details.component.scss'],
    standalone: true,
    imports: [NgIf, NgClass, CheckImageUrlDirective, AccomRoomspecComponent, MatTabsModule, AccommodationFeaturesComponent, AccommodationPriceBoxComponent, MatExpansionModule, GoogleMapsModule, FaqAccordionComponent, SliderComponent, ComponentModalFavoriteComponent, TranslateModule]
})
export class AccommodationModalDetailsComponent implements OnInit, AfterViewInit {

  /**
   * @room: required.
   * @page: optional.
   * @isReselectRoom: optional. Affiche le bouton de réservation et permet le changement de chambre d'un booking.
   */
  @Input() room: any;
  @Input() page: string;
  @Input() isReselectRoom: boolean = false;
  @Input() favList;

  /**
   * @closeModalEmitter: Required.
   * @roomIdEmitter: Optional.
   */
  @Output() closeModalEmitter = new EventEmitter<boolean>();
  @Output() roomIdEmitter = new EventEmitter<number>();

  /**
   * @roomNameSplitted: Contient le nom du logement et le numéro de la chambre.
   * @showSummary: Permet un effet de spoiler sur le résumé.
   * @locale: Permet de choisir le résumé à afficher.
   * @amenities_1: Contient les caractéristiques liées à la chambre.
   * @amenities_2: Contient les caractéristiques liées au logement.
   * @propertyPhotos: Contient les photos du logement. Required pour la modale.
   * @detailFaq: Contient la FAQ logement.
   * @options: Options de la google map. DOC OFFICIELLE : http://definitelytyped.org/docs/googlemaps.infobubble--google.maps.infobubble/interfaces/google.maps.maptypestylefeaturetype.html
   * @zoom: zoom de la map à l'initiatlisation.
   * @center center de la map à l'initialisation.
   * @roomMarker: marker de la chambre sur la map.
   * @favList: Contient tous les favoris de l'utilisateur.
   */
  roomNameSplitted: string[] = [];
  showSummary: boolean = false;
  locale: string;
  amenities_1 = [];
  amenities_2 = [];
  propertyPhotos = [];
  detailFaq;
  options: MapConfiguration = {
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.LEFT_TOP,
    },
    scrollwheel: true,
    disableDoubleClickZoom: true,
    maxZoom: 20,
    minZoom: 8,
    gestureHandling: 'greedy',
    disableDefaultUI: true,
    mapId: '6de7176f84e11418',
  };
  zoom: number = 14;
  center;
  roomMarker;

  isLoadingAmenities = false;
  noAutoScroll: boolean = false;
  isBrowser;
  public showFavErrorModal:boolean = false;


  @ViewChild('matTabGroup') matTabGroup: MatTabGroup;
  private ID_ARRAY: string[] = ['resume', 'advantages','price_infos', 'features', 'charges', 'around', 'faq_box'];

  constructor(
    private translateService: TranslateService,
    private processService: ProcessService,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private modalService: NgbModal,
    private processSharedService: ProcessSharedService,
    @Inject(PLATFORM_ID) private platformId
  ) { 
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.setMarkers();
    this.isLoadingAmenities = true;
    this.roomNameSplitted[0] = this.processService.returnAccommodationRoom(this.room.name, 'start', false);
    this.roomNameSplitted[1] = this.processService.returnAccommodationRoom(this.room.name, 'end', false);

    if (!this.favList) {
      if (this.authenticationService.currentUserValue) {
        this.processSharedService.getAccommodationFavorite().subscribe(data => this.favList = data);
      } else {
        if (this.isBrowser){
          if (localStorage && localStorage['tempFavorites']) this.favList = JSON.parse(localStorage['tempFavorites']);
        }
      }
    }

    this.processSharedService.getPageFaq('properties').subscribe(data => this.detailFaq = data);
    this.locale = this.translateService.currentLang;
    this.processSharedService.getRoomAmenities(this.room.id)
      .pipe(finalize( () => this.isLoadingAmenities = false ))
      .subscribe((data) => this.setAmenities(data));
    // Get room pictures
    this.processSharedService.getPropertyPhotos(this.room.id).subscribe(
      (data) => {
        const url = this.room.cover_photo.split('/');
        const result = Object.entries(data);
        result.map(element => {


          const regex = /https/gi;
          if (element[1].photo.search(regex) !== -1) {
            this.propertyPhotos.push(element[1].photo);
          } else {
            url[url.length - 1] = element[1].photo;
            this.propertyPhotos.push(url.join('/'));
          }
        });
      });
  }

  ngAfterViewInit() {
    const div = document.querySelector('#scroll_listener');
    // mat-tab-group active change quand reach les catégories associées
    div.addEventListener('touchmove', () => {
      this.checkScrollPosition(div);
    });
    // mat-tab-group active change quand reach les catégories associées
    div.addEventListener('wheel', () => {
      this.checkScrollPosition(div);
    });
  }


  private checkScrollPosition(scrolledElement) {
    if (scrolledElement.scrollTop === 0) {
      this.matTabGroup.selectedIndex = 0;
    } else {
      let offsetArray: number[] = [];
      this.ID_ARRAY.forEach(id => {
        if (document.getElementById(id)) {
          if (id === 'faq_box') {
            offsetArray.push(document.getElementById(id).offsetTop + 100);
          } else {
            offsetArray.push(document.getElementById(id).offsetTop - 130);
          }

        }
      });
      offsetArray.forEach(position => {
        if (scrolledElement.scrollTop >= position && (scrolledElement.scrollTop < offsetArray[offsetArray.indexOf(position) + 1] || !offsetArray[offsetArray.indexOf(position) + 1])) {
          this.noAutoScroll = true;
          this.matTabGroup.selectedIndex = offsetArray.indexOf(position);
        }
      });
    }
  }

  /**
   * Sépares les caractéristiques d'un logement en 2 catégories : room ou logement.
   * Permet de styliser l'affichage des caractéristiques.
   * @param data
   */
  setAmenities(data) {
    if (this.amenities_1.length > 0 || this.amenities_2.length > 0) return;
    Object.values(data).forEach((element: any) => {
      if (element.type_id == 1) this.amenities_1.push(element);
      if (element.type_id == 2) this.amenities_2.push(element);
    });
  }

  /**
   * Déclenche la fermeture de la modale depuis le composant parent.
   * Le composant accommodation-modal-details est alors détruit.
   */
  closeModal() {
    this.closeModalEmitter.emit(true);
  }

  /**
   *
   */
  setMarkers(): void {
    this.center = [this.room.property_address.latitude, this.room.property_address.longitude];
    this.roomMarker = {
      position: {
        lat: parseFloat(this.room.property_address.latitude),
        lng: parseFloat(this.room.property_address.longitude),
      },
      options: {
        icon: 'assets/img/map/property_selectedPlace.svg'
      },
    };
  }

  /**
   *
   * @param id
   */
  addToFavorites(id) {
    this.showFavErrorModal = this.processService.addToFavorite(this.favList, id);
  }

  /**
   * Ouvre la modal photos du logement.
   * @param e
   */
  openModal(e) {
    this.modalService.open(e, {size: 'xl'});
  }

  /**
   * Permet de scroll jusqu'à l'élément souhaité quand on clic sur le menu sticky.
   * @param tabIndex
   */
  tabChanges(tabIndex: number) {
    const element = document.getElementById(this.ID_ARRAY[tabIndex]);
    let top;
    if (this.ID_ARRAY[tabIndex] === 'faq_box') {
      top = element.offsetTop + 230;
    } else {
      top = element.offsetTop - 62;
    }

    const mainElement = document.getElementById('scroll_listener');
    if(!this.noAutoScroll){
      mainElement.scrollTo({top:top, behavior:'smooth'});
    }
    this.noAutoScroll = false;
  }

  /**
   * Retourne true si l'élément est un favori de l'utilisateur, sinon retourne false.
   * Permet de styliser le bouton favoris.
   * @param id
   */
  isFavorite(id) {
    const index = this.favList.indexOf(id.toString());
    if (index !== -1) return 'favorite';
    return 'not-favorite';
  }

  /**
   * Envoie l'id de la room choisie au composant parent.
   * Activable uniquement si la page est "booking : logement indisponible"
   * @param currentRoom
   */
  changeRoom(currentRoom) {
   this.roomIdEmitter.emit(currentRoom.id);
  }

}
